import Link from 'next/link'
import { useContext, useEffect, useState } from 'react'

const Bag = '/images/svg/bag-cart.svg'
const ImagemPadrao = `${process.env.INTERNAL_IMAGES_URL}/images/jpg/produto-default.jpg`

import { formatarPreco } from '../../util/formatar'
import Carregando from '../carregando'
import GImage from '../gImage'
import { IconCart } from '../header/icons/cart'
import { theme } from 'src/styles/themes/default'
import { Box, IconTrash } from '@gazin/ecommerce-ui'
import { useCartContext } from 'src/contexto/cartContext'

const activeCart = () => {
  const dropCadastro = document.querySelector('header .area-user')
  const divCart = document.querySelector('.area-cart')
  const overlay = document.querySelector('.overlay')

  divCart.classList.add('active')
  dropCadastro.classList.remove('active')
  overlay.classList.add('active')
}

export const hiddenCart = () => {
  const divCart = document.querySelector('.area-cart')
  const overlay = document.querySelector('.overlay')

  divCart.classList.remove('active')
  overlay.classList.remove('active')
}

const toggleCart = () => {
  const dropCadastro = document.querySelector('header .area-user')
  const divCart = document.querySelector('.area-cart')
  const overlay = document.querySelector('.overlay')

  divCart.classList.toggle('active')
  dropCadastro.classList.remove('active')

  overlay.classList.toggle('active')
}

export default function Cart(props) {
  const [totalCarrinho, setTotalCarrinho] = useState(0)
  const [totalQuantidade, setTotalQuantidade] = useState(0)
  const carrinho = useCartContext()

  useEffect(() => {
    const itens = carrinho.carrinhoStore?.carrinhos_itens

    setTotalCarrinho(
      itens?.reduce(
        (acc, current) => acc + current.anuncio.preco.por * current.quantidade,
        0
      )
    )
    setTotalQuantidade(
      itens?.reduce((acc, current) => acc + current.quantidade, 0) ?? 0
    )
  }, [carrinho.carrinhoStore?.carrinhos_itens])

  const getTituloProduto = (produto) => {
    let produtoTitulo = produto?.variacao?.titulo ?? ''
    const fixedPayload =
      produto?.titulo_produto && produto?.variacao?.combinacoes_lista

    if (fixedPayload) {
      const suffix =
        produto.variacao?.combinacoes_lista
          ?.map((value) => {
            const combinacao = value?.valor

            return combinacao ? ' - ' + combinacao : ''
          })
          .join('') ?? ''

      produtoTitulo = produto.titulo_produto + suffix
    }

    return produtoTitulo
      .replace(' - Sem Cor', '')
      .replace(' - Sem Voltagem', '')
  }

  return (
    <>
      <div
        className="area-cart"
        onMouseOver={() => activeCart()}
        onClick={() => toggleCart()}
      >
        <button
          className="btn-show-cart"
          type="button"
          style={{ gap: `1rem`, display: 'flex', alignItems: `center` }}
          aria-label="Carrinho"
        >
          <IconCart
            size="21"
            color={props.buttonCartTextColor || theme.colors.white}
          />
          <Box as='span' visibility={carrinho.loadingCarrinho ? 'hidden' : 'visible'}>
            {totalQuantidade}
          </Box>
        </button>

        <div className="dropdown-cart" onMouseLeave={() => hiddenCart()}>
          {!carrinho.carrinhoStore?.carrinhos_itens?.length ? (
            <div className="empty-cart" id="js-cart-empty">
              <img src={Bag} alt="Carrinho Vazio" width="130" height="130" />
              <h3>Carrinho vazio</h3>
            </div>
          ) : (
            <div className="cart-full">
              <div className="all-prods">
                {carrinho.carrinhoStore.carrinhos_itens.map((produto, key) => (
                  <div className="item" key={key}>
                    <div className="photo">
                      <Link href={`${produto.url_produto}`}>
                        <GImage
                          src={produto.imagem?.url ?? ImagemPadrao}
                          alt={produto.variacao.titulo}
                          width={44}
                          height={44}
                          sizes="44px"
                        />
                      </Link>
                    </div>
                    <div className="info">
                      <Link href={`${produto.url_produto}`}>
                        <h3>{getTituloProduto(produto)}</h3>
                      </Link>
                      <div className="valor-qtd">
                        <span>Quantidade: {produto.quantidade}</span>
                        <h4></h4>
                      </div>
                      <button
                        type="button"
                        onClick={() => carrinho.remover(produto.anuncio.id)}
                        aria-label="Remover item do carrinho"
                      >
                        <IconTrash color="#A0A4B3" />
                      </button>
                    </div>
                  </div>
                ))}
              </div>
              <div className="total">
                <span>Valor total</span>
                <h3>{formatarPreco(totalCarrinho)}</h3>
              </div>
              <Link
                href={`${process.env.NEXT_PUBLIC_CHECKOUT_APP_URI}`}
                as={`${process.env.NEXT_PUBLIC_CHECKOUT_APP_URI}`}
                className="btn-continuar"
              >
                continuar
              </Link>
            </div>
          )}
        </div>
      </div>
    </>
  )
}
